import React from 'react';

export const Select = props => {
  const renderSelectOptions = (key, index) => {
    return (
      <option key={`${index}-${key}`} value={key}>
        {props.options[key]}
      </option>
    );
  };

  if (props && props.options) {
    return (
      <div className="form-group">
        <label className="col-md-2 control-label">{props.label}</label>
        <div className="col-md-10">
          <select {...props.input} className="form-control">
            <option value="">Select</option>
            {Object.keys(props.options).map(renderSelectOptions)}
          </select>
        </div>
      </div>
    );
  }
  return <div></div>;
};

export default Select;



// WEBPACK FOOTER //
// ./src/routes/administration/components/Select.js